module.exports = __webpack_public_path__ + "static/scale-model-of-richardson-texas-5298e93a364891b74dcebc125861c422.png";